import axios from 'axios';

/* ===========================================================
   🔹 CRIAR PAGAMENTO PIX (ASAAS)
   =========================================================== */
export async function criarPix(body) {
  // Recuperar o token JWT do localStorage
  const token = localStorage.getItem('token');
  if (!token) throw new Error('Token não encontrado. Faça login novamente.');

  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Inclui o token no cabeçalho
        'Content-Type': 'application/json',
      },
    };

    // Chamada para o backend (rota ASAAS)
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/payments/criar-pix`,
      body,
      config
    );

    /* Backend ASAAS retorna:
      {
        paymentId: "pay_123456",
        valor: 179,
        qrCode: "data:image/png;base64,...",
        copiaCola: "00020126580014BR.GOV.BCB.PIX..."
      }
    */

    return data;
  } catch (error) {
    console.error('Erro na criação do Pix:', error.response?.data || error.message);
    throw error;
  }
}

/* ===========================================================
   💳 PAGAMENTO COM CARTÃO (AINDA USANDO MERCADO PAGO)
   =========================================================== */
export async function postCredit({
  token,
  issuer_id,
  payment_method_id,
  transaction_amount,
  installments,
  email,
  identificationType,
  identificationNumber,
  userId,
  firstName,
  lastName,
  phoneAreaCode,
  phoneNumber,
}) {
  const jwtToken = localStorage.getItem('token');
  if (!jwtToken) throw new Error('Token não encontrado. Faça login novamente.');

  const body = {
    token,
    issuer_id,
    payment_method_id,
    transaction_amount,
    installments,
    description: 'Assinatura indicadores',
    payer: {
      email,
      first_name: firstName,
      last_name: lastName,
      identification: { type: identificationType, number: identificationNumber },
      phone: {
        area_code: phoneAreaCode,
        number: phoneNumber,
      },
    },
    external_reference: userId,
  };

  console.log('Body enviado ao backend:', body);

  try {
    const config = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/payments/process_payment`,
      body,
      config
    );

    return data;
  } catch (error) {
    console.error('Erro ao processar pagamento com cartão:', error.response?.data || error.message);
    throw error;
  }
}

/* ===========================================================
   🔎 VERIFICAR STATUS DO PAGAMENTO
   =========================================================== */
export async function verificarStatusPagamento(transactionId) {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/payments/status/${transactionId}`
    );
    return data.status; // Retorna apenas o status (ex: "paid", "pending")
  } catch (error) {
    console.error('Erro ao verificar status do pagamento:', error.response?.data || error.message);
    throw error;
  }
}

/* ===========================================================
   💰 CONSULTAR VALOR DO PIX (DESCONTO APLICADO)
   =========================================================== */
export async function consultarValorPix(userId) {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado. Faça login novamente.");

  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/payments/consultar-valor/${userId}`,
      config
    );

    // Esperado: { transaction_amount: valor }
    return data;
  } catch (error) {
    console.error("Erro ao consultar valor PIX:", error.response?.data || error.message);
    throw error;
  }
}
